<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM日销售数据（元）"
      rightTitle="2022年12月 合计：999"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="center_2" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "center_2",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_2"));
      this.setOptions();
    },
    setOptions() {
      let data = [
        {
          value: 398,
        },
        { value: 428 },
        { value: 298 },
        { value: 128 },
        { value: 298 },
        { value: 418 },
        { value: 398 },
        { value: 198 },
        { value: 298 },
        { value: 300 },
        { value: 128 },
        { value: 328 },
        { value: 248 },
        { value: 178 },
        { value: 228 },
        { value: 398 },
        { value: 428 },
        { value: 298 },
        { value: 128 },
        { value: 298 },
        { value: 418 },
        { value: 398 },
        { value: 198 },
        { value: 298 },
        { value: 300 },
        { value: 128 },
        { value: 328 },
        { value: 248 },
        { value: 178 },
        { value: 228 },
        { value: 398 },
      ];
      const color = ["0, 157, 255", "34, 228, 255", "59, 255, 208"];
      data = data.map((m, i) => {
        return {
          value: m.value,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
              { offset: 0, color: `rgba(${color[i % 3]},0.1)` },
              { offset: 1, color: `rgba(${color[i % 3]},1)` },
            ]),
          },
        };
      });
      let xData = [];
      for (let i = 1; i <= 31; i++) {
        xData.push(i);
      }
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "10%",
          right: "9%",
          top: "15%",
          bottom: "1%",
          containLabel: true,
        },
        legend: {
          show: false,
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            interval: 50,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
                type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
              },
            },
          },
          {
            show: false,
          },
        ],
        series: [
          {
            name: "销售额",
            type: "bar",
            barWidth: 5,
            data: data,
            itemStyle: {
              borderRadius: 5,
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 30vh;
  #center_2 {
    height: calc(100% - 30px);
  }
}
</style>
